<form nz-form class="form" nzLayout="vertical">
  <div class="add-user-tabs">
    <nz-tabset [(nzSelectedIndex)]="selectedTabIndex">
      <nz-tab nzTitle="Frequency Interval"
        ><app-frequency-interval
          (saveAndNext)="handleSaveAndNext($any($event))"
      /></nz-tab>
      <nz-tab nzTitle="Frequency Only"
        ><app-frequency-only (saveAndNext)="handleSaveAndNext($any($event))" />
      </nz-tab>
    </nz-tabset>
  </div>
</form>
